module.exports = __webpack_public_path__ + "img/works_titleist_m_btm.7d0686b4.png";